/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject, Input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {interpolateWarning} from "./interpolate-warnings-filter";
import {LocalNetworkProfile} from '../../../../components/session/local-network-profile';

@Component({
  imports: [CommonModule],
  selector: 'simple-validation-messages',
  template: `
    <div>
      <!-- Must be on one line with no white space to ensure :empty CSS style works -->
      <div class="alert alert-warning"><p *ngFor="let warning of warnings">{{ interpolateWarning(warning) }}</p></div>
    </div>
  `
})
export class SimpleValidationMessagesComponent {
  @Input() warnings: any;

  constructor(@Inject(LocalNetworkProfile)private LocalNetworkProfile) {
  }

  interpolateWarning(warning) {
    return interpolateWarning(warning, this.LocalNetworkProfile.isPureMarketplacePlatform());
  }
}
